export const localeMap: Record<string, string> = {
  fr: 'fr-FR',
  en: 'en-US',
  de: 'de-DE',
};

export const getCompleteLocale = (lang?: string) => (lang ? localeMap[lang] : 'fr-FR');
